import { Component, OnInit, Inject, Input } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ConnectionService } from 'src/app/modules/organization/connection.service';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { CommonModule, Location } from '@angular/common';
import { BoxService } from 'src/app/shared/services/box.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ObjectExplorerService } from 'src/app/shared/object-explorer/object-explorer.service';
import { SpinnerModule } from 'src/app/shared/spinner/spinner.module';
import { ListPanelModule } from 'src/app/bloom/specialized-panels/list-panel/list-panel.module';
import { WidgetManager } from 'src/app/bloom/models/WidgetManager';
import { StarchService } from 'src/app/shared/services/starch.service';
import { BoxInstance } from 'src/app/core/boxInstances/BoxInstance';
import { TokenUtil } from 'src/app/core/services/TokenUtil.service';
import { CacheService } from 'src/app/core/services/CacheService';

@Component({
    selector: 'objects-listing',
    templateUrl: './objects-listing.component.html',
    styleUrls: ['./objects-listing.component.css'],
    imports: [MatTooltipModule, MatIconModule, MatButtonModule, MatFormFieldModule, MatInputModule, MatChipsModule, FlexLayoutModule, CommonModule, SpinnerModule, ListPanelModule]
})

export class ObjectsListingComponent implements OnInit {
  constructor(
    private router: Router,
    private token: TokenUtil,
    private route: ActivatedRoute,
    private boxService: BoxService,
    private starchService: StarchService,
    private objectExplorerService: ObjectExplorerService,
    private cs: CacheService
  ) {}

  @Input() starch: any;
  @Input() connection: any;
  @Input() box: any;

  objects: any[] = []
  filteredObjects: any[] = []
  objectsLoaded: boolean = false
  spinner: boolean = false

  listPanelMeta = {
    type: "listpanel",
    viewTypes: {
      defaultView: "card",
      card: { cardSize: "small" }
    },
    listPanelTitle: ' ',
    listAttributes: [
      {
        __id: "logo",
        name: "logo",
        dataType: 'string',
        filterable: false,
        sortable: false,
        sortEnabled: false,
        show_hide: false,
        fieldType: 'attribute',
        widgetType: 'image'
      },
      {
        __id: "object_logo",
        name: "object_logo",
        dataType: 'string',
        filterable: false,
        sortable: false,
        sortEnabled: false,
        show_hide: false,
        fieldType: 'attribute',
        widgetType: 'image'
      },
      {
        __id: "name",
        name: "Name",
        dataType: 'string',
        filterable: false,
        sortable: false,
        sortEnabled: false,
        show_hide: false,
        fieldType: 'attribute',
        widgetType: 'label'
      },
    ],
    listWidgetSet: {},
    navigationSettings: {
      "enabled": true,
      "navFilterAttributes": [],
      "pageCode": "",
      "tooltip": "Click to explore",
      "type": "internal"
    }
  };

  showMoreChip = {
    __id: "__SHOWMORE__",
    type: "__SPECIAL__",
    name: "Show more...",
  }

  showLessChip = {
    __id: "__SHOWLESS__",
    type: "__SPECIAL__",
    name: "Show less",
  }

  ngOnInit(): void {
    console.log("connection", this.connection)
    console.log("box", this.box)
    this.getObjects()


    this.setWidgetStyles()
  }

  setWidgetStyles(){
    // add formatted widget for logo
    let logoWidget = WidgetManager.getWidget('image')
    let object_logo = WidgetManager.getWidget('image')
    logoWidget.config.width.value = '20%'
    logoWidget.config.imageAlignment.value = "left"
    object_logo.config.width.value = '60%'
    this.listPanelMeta.listWidgetSet['logo'] = logoWidget
    object_logo.config.value.value = "https://storage.googleapis.com/jivrus-web-images/products/appiworks/connection/aw-connection-objects-logo.png"
    object_logo.config.value.resetValue = "https://storage.googleapis.com/jivrus-web-images/products/appiworks/connection/aw-connection-objects-logo.png"
    this.listPanelMeta.listWidgetSet['object_logo'] = object_logo
    console.log("logoWidget, object_logo", object_logo)
    // text formatting for object name
    let nameWid = WidgetManager.getWidget('label')
    nameWid.textFormat.bold.value = true
    nameWid.textFormat.fontSize.value = 16
    nameWid.textFormat.color.value = "#3f51b5"
    nameWid.config.alignment.value = "center"
    this.listPanelMeta.listWidgetSet['name'] = nameWid
    console.log("this.listPanelMeta.listWidgetSet", this.listPanelMeta.listWidgetSet)
  }

  async getObjects() {
    console.log("get objects")
    this.spinner = true
    try {
      if(this.starch){
        this.objects = await this.starchService.getBaseObjects(this.starch);
      }else if (this.connection) {

        let cache = await this.checkCache()
        if(cache) {
          this.objects = cache.objects
          console.log("objects retrieved from cache", this.objects)
          // return
        }else{
          this.objects = await this.boxService.getBoxObjects(this.connection._id,this.connection.box_id, false);
        }
      }
      // if (this.box?.supports?.includes('customobject')) {
      //   this.objects.push({name: '__custom'});
      // }
    } catch (error) {
      this.spinner = false
      console.error('Could not fetch objects :', error);
    }
    console.log('OBJECTS', this.objects);

    // this.filteredObjects = JSON.parse(JSON.stringify(this.objects))
    this.objects.forEach(obj => {
      this.filteredObjects.push({
        logo: this.starch ? this.starch['logo'] : this.box.logo,
        name: obj.name,
        description: obj.description || this.generateDescription()
      })
    })
    this.objectsLoaded = true
    this.spinner = false
  }


  async checkCache(){
    let chOptions: any = {keyPrefix: "box_objects_", isLocalStorage: false, clearCache: false, "avoidAuthKey": true};
    let url = await BoxInstance.getInstance(`/${this.box.__id}/objects`);
    url = url + `/${this.box.__id}/objects`
    let token = this.token.getStatelessToken()
    const headers = {
      boxConfigToken: this.connection.box_token,
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    }
    const cacheKey = this.cs.getCacheKey(url, { headers: headers }, null, chOptions);
    let cachedData = this.cs.getData(cacheKey, chOptions)
    if(cachedData) return cachedData
  }

  /**
   * TODO
   * apply reccommended strategies to generate object description if not present
   * use softcoding
   */
  generateDescription(){
    return ""
  }

  showMore(){
    this.filteredObjects.pop()
    this.filteredObjects = JSON.parse(JSON.stringify(this.objects))
    this.filteredObjects.push(this.showLessChip)
  }

  showLess(){
    this.filteredObjects.pop()
    this.filteredObjects = this.filteredObjects.slice(0, 15)
    this.filteredObjects.push(this.showMoreChip)
  }

  searchObjects(event: any){
    if(event.srcElement.value == ''){
      // this.filteredObjects = JSON.parse(JSON.stringify(this.objects))
      // if(this.filteredObjects.length > 15){
      //   this.filteredObjects = this.filteredObjects.slice(0, 15)
      //   this.filteredObjects.push(this.showMoreChip)
      // }
      this.objects.forEach(obj => {
        this.filteredObjects.push({
          logo: this.box.logo,
          name: obj.name,
          description: obj.description || this.generateDescription()
        })
      })
      return
    }
    this.filteredObjects = []
    for (let i = 0; i < this.objects.length; i++) {
      if(this.objects[i].name.toLowerCase().includes(event.srcElement.value)){
        this.filteredObjects.push({ 
          name: this.objects[i].name,
          logo: this.box.logo,
          description: this.objects[i].description || this.generateDescription()
        })
      }
    }
  }

  exploreObject(id){
    if(id == '__SHOWMORE__') {
      this.showMore();
      return;
    } else if (id == '__SHOWLESS__'){
      this.showLess();
      return;
    }

    let object = this.objects.find(obj => obj.__id == id)
    // if(this.connection) this.objectExplorerService.setConnectionData(this.connection)
    // if(this.starch) this.objectExplorerService.setBaseData(this.starch)
    this.objectExplorerService.parentObject.next(object)
    if(this.connection){
      this.router.navigate(['./' + id], {
        relativeTo: this.route,
        queryParams: {
          connectionid: this.connection._id
        }
      }); 
    }else if(this.starch){
      this.router.navigate(['./' + id], {
        relativeTo: this.route,
        queryParams: {
          baseid: this.starch._id
        }
      }); 
    }
  }

  rowClicked(data){
    console.log("object clicked", data)
    let clickedObject = this.objects.find(obj => obj.name == data.data.name.value)
    this.exploreObject(clickedObject.__id)
  }
}
